import { isSetter } from '../utils/guards.js';
const withSerialization = ({ atom, serialize: customSerialize, deserialize: customDeserialize, pure = false, }) => {
    const serialize = (value) => (value === undefined ? undefined : customSerialize(value));
    const deserialize = (value) => (value === undefined ? undefined : customDeserialize(value));
    const get = async () => {
        const serialized = await atom.get();
        return deserialize(serialized);
    };
    const set = async (value) => {
        if (isSetter(value)) {
            return atom.set(async (previousValue) => {
                const deserialized = await deserialize(previousValue);
                const updated = await value(deserialized);
                if (pure && updated === deserialized)
                    return previousValue;
                return serialize(updated);
            });
        }
        const serialized = await serialize(value);
        return atom.set(serialized);
    };
    const observe = (callback) => {
        return atom.observe(async (value) => callback(await deserialize(value), value));
    };
    return { ...atom, get, set, observe };
};
export default withSerialization;
